<template>
<div class="button1 text-left">
    <button @click="goHome" class="btn btn-dark text-left">new search</button>
</div>
</template>

<script>
export default {
  name: 'buttonSrart',
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  watch: {
    $route(to) {
      this.id = to.params.id;
    },
  },
  methods: {
    goHome() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.button1
{
 padding-left: 20px;
 padding-top: 2px;
}
</style>
